<template>
    <div class="modal-overlay">
        <div class="modal">
            <div class="modal-content" id="login">
                <div class="modal-header">
                    <h2 title="Update #1">Payroll Self-Reporting Login</h2>
                </div>
                <div class="modal-main-content">
                    <ErrorList v-if="error" :error="error"/>
                    <form>
                        <div class="formrow">
                            <label for="username">Username:</label>
                            <input type="text" name="username" id="username" v-model="input.username" placeholder="Username" @keyup.enter="onLogin"/>
                        </div>
                        <div class="formrow">
                            <label for="password">Password:</label>
                            <input type="password" name="password" id="password" v-model="input.password" placeholder="Password" @keyup.enter="onLogin"/>
                        </div>
                        <div class="formrow" v-if="isAccountManager()">
                            <label for="reportingDate" style="padding-right: 1rem;">Reporting Date:</label>
                            <input type="date" name="reportingDate" id="reportingDate" v-model="input.reportingDate" placeholder="YYYY-MM-DD" style="width: 50%;" @keyup.enter="onLogin"/>
                        </div>
                        <div class="formcontrols">
                            <button type="button" @click="onLogin" class="button-sm purple">Login</button>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <h3>Problems logging in?</h3>
                    <p>Contact your Account Manager at <a href="tel:+18447618400">844-761-8400</a> for password info.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { isAccountManager, onLogout } from '@/utils/helpers'
import ErrorList from './shared/ErrorList'
import moment from 'moment'

export default {
    name: 'Login',
    components: { ErrorList },
    data() {
        return {
            input: {
                username: '',
                password: '',
                reportingDate: ''
            },
            error: null
        }
    },
    computed: {
        ...mapState([ 'policies' ])
    },
    methods: {
        onLogin: function (event) {
            if (!this.input.username || !this.input.password) {
                this.error = { message: 'Please enter your username and password.' }

            } else {
                this.error = null
                this.reportingDate = (this.input.reportingDate !== '') ? moment(this.input.reportingDate) : null
                Vue.prototype.$log.debug('Reporting Date: ' + moment(this.reportingDate).format('YYYY-MM-DD HH:mm'))
                event.target.blur()
                this.$store.dispatch('login', {
                    username: this.input.username,
                    password: this.input.password,
                    isAdmin: this.isAccountManager()

                }).then(() => {
                    return this.$store.dispatch('fetchPolicies', {
                        reportingDate: this.reportingDate
                    })

                }).then(() => {
                    if (this.policies.length > 0) {
                        Vue.prototype.$log.debug("Found policies")
                        this.$router.push({ name: 'Reporting' })

                    } else if (this.policies.length === 0) {
                        Vue.prototype.$log.debug("Found no policies")
                        this.$router.push({ name: 'NoReporting' })

                    } else {
                        this.error = { message: 'No payroll policies found for provided username.' }
                        onLogout(this)
                    }

                }).catch((error) => {
                    this.error = error
                    event.target.focus()
                })
            }
        },
        isAccountManager
    }
}
</script>
